import { useState } from 'react';
import { RiArrowDropDownLine } from 'react-icons/ri';

const SelectBox = ({ options, selectedOptions, onChange, onRemove, error }) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleDropdown = () => setIsOpen(!isOpen);

    return (
        <div className="relative">
            <label htmlFor="franchise_model" className="mb-1 font-md block capitalize">
                Franchise Model <span className="text-star_color">*</span>
            </label>

            <div
                id="franchise_model"
                name="franchise_model"
                onClick={toggleDropdown}
                className={`p-2 relative border bg-white border-gray-300 rounded w-full flex mb-2 cursor-pointer ${error ? 'border-red-500' : ''}`}
            >
                {selectedOptions.map((model) => (
                    <div
                        key={model}
                        className="flex items-center text-white py-1 px-2 rounded"
                    >
                        <span className='text-[black]'>{model}</span>
                        <button
                            type="button"
                            onClick={() => onRemove(model)}
                            className="ml-2 border text-black rounded-full w-5 h-5 flex items-center justify-center"
                        >
                            &times;
                        </button>
                    </div>
                ))}

                <span className="text-gray-500">
                    {selectedOptions.length === 0 ? 'Select Franchise Model' : ''}
                </span>

                {isOpen && (
                    <div className="absolute top-full left-0 w-full mt-1 bg-white border border-gray-300 rounded shadow-lg z-10">
                        {options.map((option) => (
                            <div
                                key={option.value}
                                onClick={() => {
                                    onChange(option.value);
                                    toggleDropdown();
                                }}
                                className="p-2 hover:bg-gray-200 cursor-pointer"
                            >
                                {option.value}
                            </div>
                        ))}
                    </div>
                )}
                <RiArrowDropDownLine className='absolute text-[#737a87] text-[35px] right-0 top-[1px]' />
            </div>

            {error && (
                <p className="text-star_color text-sm">
                    {error}
                </p>
            )}
        </div>
    );
};


export default SelectBox